import { useContext } from "react";
import { MyChimneyContext, MyChimneyContextType } from "./MyChimneyContext";

export const useMyChimneyContext = (): MyChimneyContextType => {
  const context = useContext(MyChimneyContext);
  if (context == null) {
    throw new Error(
      "useMyChimneyContext must be used within a MyChimneyContextProvider"
    );
  }
  return context;
};
